function BusinessOrIndividualStep(data, isBusinessObservableReference) {
    var self = this;
    BaseStepModel.apply(self, ['business_or_individual_panel']);

    self.isBusiness = isBusinessObservableReference;
    self.businessOrIndividualModel = data;

    self.setIndividual = function() {
        self.isBusiness(false);
        self.isDone(true);
    }

    self.setBusiness = function() {
        self.isBusiness(true);
        self.isDone(true);
    };

    self.show = function () {
        self.resetState();
        registrationArea.showBusinessOrIndividualPanel();
    }
}